<mat-form-field mat-select-height-large>
  <mat-label>{{ titleKey | translate }}</mat-label>
  <mat-select [(ngModel)]="selectedValue" (ngModelChange)="onSelect()" fieldTextContentTooltip>
    <mat-option
      [attr.data-at-dropdown-option]="option.value"
      fieldTextContentTooltip
      *ngFor="let option of options"
      [value]="option"
    >
      {{ option.viewValue }}
    </mat-option>
  </mat-select>
</mat-form-field>
